import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import { useWebServer } from "../../../../../providers";
import { loadImagingData } from "../../../../../actions";
import { Reports } from "./Reports";

const Index = ({ loadImagingData, data }) => {
  const { downloadWeeklyImaging } = useWebServer();
  const history = useHistory();

  useEffect(() => {
    loadImagingData(downloadWeeklyImaging);
    //eslint-disable-next-line
  }, []);

  const handleButtonClick = (buttonClicked) => {
    history.push(`${ROUTES.reports}?button=${buttonClicked}`);
  };

  return <Reports data={data} handleButtonClick={handleButtonClick} />;
};

export const mapStateToProps = (state) => {
  return {
    data: state?.report?.monthlyData?.data,
  };
};
export default connect(mapStateToProps, { loadImagingData })(Index);
